import {ProcessHook, ProcessHookProps, ProcessHookRunProps} from "./process-hooks";
import {JsonObject} from "typescript-json-serializer";


/**
 * Hook to clean up partial orders
 * Users can change project type. Partial orders depend on project type.
 * When adding GHK partial orders and changing type to GK, GHK partial orders have to be cleaned up
 */
@JsonObject()
export class CleanupPartialOrdersHook extends ProcessHook {

    class = "CleanupPartialOrdersHook";
    constructor(props?: ProcessHookProps) { super(props); }

    run(runProps: ProcessHookRunProps): Promise<any> {
        return new Promise((resolve, reject) => {
            const {project, auftragsverwaltung} = runProps;

            if (!project?.id || !project?.typeId) {
                reject("ID oder type undefined on project.");
                return;
            }

            const promises = [
                /**
                 * !!! do not clean up partial order risk here with PartialOrderRiskStore.
                 * PartialOrderRiskStore does point to the same layer as PartialOrderGkStore and it would remove
                 * all partial orders.
                 * There is no overlap of GK and Risk projects, because project ID are having a different range.
                 * No need to clean up Risk partial orders
                 */
                this.cleanupPartialOrdersGk(project, auftragsverwaltung),
                this.cleanupPartialOrdersGhk(project, auftragsverwaltung)
            ];
            Promise.all(promises).then(() => {
                resolve("Teilaufträge bereinigt");
            }).catch((error) => {
                reject(error);
            });
        });
    }

    /**
     * Cleanup GK partial orders
     * (when project type is 2: Gefahrenhinweiskarte)
     * @param project
     * @param auftragsverwaltung
     * @private
     */
    private cleanupPartialOrdersGk(project, auftragsverwaltung): Promise<string> {
        return new Promise((resolve) => {
            if (project.typeId !== 2) {
                // do only clean up GK partial orders when project type is Gefahrenhinweiskarte
                resolve("Nichts zu bereinigen.");
                return;
            }
            if (!project?.id) {
                // stop! otherwise all partial orders could be deleted
                resolve("Keine Projekt ID.");
                return;
            }
            // remove GK partial orders
            auftragsverwaltung.PartialOrderGkStore.loadItems(project.id).then((po) => {
                if (po && po.length > 0) {
                    const promises = po.map((p) => {
                        auftragsverwaltung.PartialOrderGkStore.delete(project, p, "hook@lu.ch");
                    });
                    Promise.all(promises).then(() => {
                        resolve("Teilaufträge Gefahrenkarte entfernt.");
                    });
                } else {
                    resolve("Keine Teilaufträge Gefahrenkarte");
                }
            });
        });
    }

    /**
     * Cleanup GK partial orders
     * (when project type is 1: Gefahrenkarte)
     * @param project
     * @param auftragsverwaltung
     * @private
     */
    private cleanupPartialOrdersGhk(project, auftragsverwaltung): Promise<string> {
        return new Promise((resolve) => {
            if (project.typeId !== 1) {
                // do only cleanup GHK partial orders when project type is Gefahrenkarte
                resolve("Nichts zu bereinigen.");
                return;
            }
            if (!project?.id) {
                // stop! otherwise all partial orders could be deleted
                resolve("Keine Projekt ID.");
                return;
            }
            // remove GHK partial orders
            auftragsverwaltung.PartialOrderGhkStore.loadItems(project.id).then((po) => {
                if (po && po.length > 0) {
                    const promises = po.map((p) => {
                        auftragsverwaltung.PartialOrderGhkStore.delete(project, p, "hook@lu.ch");
                    });
                    Promise.all(promises).then(() => {
                        resolve("Teilaufträge Gefahrenhinweiskarte entfernt.");
                    });
                } else {
                    resolve("Keine Teilaufträge Gefahrenhinweiskarte");
                }
            });
        });
    }
}
